import { matchPath } from "react-router-dom";
import { put, select, take, call, takeLeading } from "redux-saga/effects";
import AuthProvider from "shared/authProvider";
import { shouldAuthenticate } from "utils/auth";
import logger from "utils/logger";
import BackendClient from "api/backend-client";
import { CommonApiMethods } from "api/api-methods";
import { AuthActionType, loginFailure, loginSuccessful } from "./auth.actions";
import { isAuthenticatedSelector } from "./auth.selectors";
import { ERROR_FORBIDDEN } from "api/api-error";
import RoutePaths from "routes/route-paths";
import { fetchAllowedUsersSaga } from "store/users/users.saga";
import { navigate } from "shared/navigation";
import { toErrorString } from "utils/error";
function* login() {
    try {
        const doAuthenticate = yield call(shouldAuthenticate);
        if (!doAuthenticate)
            return;
        const auth = yield call([AuthProvider, AuthProvider.getInstance]);
        const account = yield call([auth, auth.checkAuth]);
        if (!account) {
            yield call([auth, auth.login]);
            return;
        }
        const backendClient = BackendClient.getInstance();
        const userInfo = yield call([backendClient, CommonApiMethods.UserInfo]);
        yield put(loginSuccessful(userInfo));
    }
    catch (e) {
        const msg = toErrorString(e);
        loginFailure({
            message: e?.message ?? msg,
            code: e?.errorCode ?? e?.code ?? e?.response?.status,
        });
        logger.error(`login failed: ${msg}`);
    }
}
function* logout() {
    try {
        const auth = yield call([AuthProvider, AuthProvider.getInstance]);
        yield call([auth, auth.logout]);
    }
    catch (e) {
        logger.error(`login is failed: ${e.message}`);
    }
}
export function* waitForLogin() {
    const isAuthenticated = yield select(isAuthenticatedSelector);
    if (!isAuthenticated) {
        yield take(AuthActionType.LOGIN_SUCCESSFUL);
    }
}
export function* checkForbidden(e) {
    if (e?.status === ERROR_FORBIDDEN ||
        (e?.response?.status === ERROR_FORBIDDEN && !matchPath(window.location.pathname, RoutePaths.Unauthorized))) {
        try {
            yield call(fetchAllowedUsersSaga);
        }
        catch (e) {
            logger.error("fetch users is failed");
        }
        finally {
            yield call(navigate, RoutePaths.Unauthorized, null, true);
        }
    }
}
export default function* authSaga() {
    yield takeLeading(AuthActionType.LOGIN, login);
    yield takeLeading(AuthActionType.LOGOUT, logout);
}
